module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-Quote-lewis-name.3c84592.png";